<template>
    <div class="replacement-destination" v-if="isShow">
        <div class="replacementDestin-bg" @click="close"></div>
        <div class="destination-content">
            <div class="destinationCountry-city">
                <div class="destination-islet" style="height: 663px;">
                    <ul>
                        <li v-for="(item, index) in options" :key="index" v-bind:class="{active: activeContinent === index}" @click="selectContinent(index)">
                            <span class="isletName">{{item.continent}}</span>
                        </li>
                    </ul>
                </div>
                <div class="destination-countryCity">
                    <div class="destination-country" style="height: 663px;">
                        <ul>
                            <li v-for="item in countryOptions" :key="item.id" v-bind:class="{active: activeCountry === item.id}" @click="selectCountry(item)">
                                <span class="countName">{{item.countryCNName}}</span>
                            </li>
                        </ul>
                    </div>
                    <div class="destination-city" style="height: 663px;">
                        <ul class="scroll-container">
                            <li v-for="item in cityOptions" :key="item.id" v-bind:class="{active: activeCity === item.id}" @click="selectCity(item)">
                                <span class="cityName">
                                    <a href="javascript: void(0)" class="external">{{item.cityCNName}}</a>
                                </span>
                                <img src="../../assets/checkedImg.png">
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { delayDev } from '@/utilities/tools'
    export default {
        name: 'DestinationOption',
        props: {
            isShow: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                default: function () {}
            },
            continent: {
                type: String,
                default: ''
            },
            country: {
                type: String,
                default: ''
            },
            city: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                countryOptions: [],
                cityOptions: [],
                activeContinent: 0,
                activeCountry: 0,
                activeCity: 0
            }
        },
        watch: {
            'isShow' (newVal) {
                if (newVal) this.show()
            }
        },
        methods: {
            show () {
                let continentItem = this.options.find(item => item.continent === this.continent)
                this.activeContinent = this.options.indexOf(continentItem)
                this.countryOptions = continentItem.list

                let countryItem = this.countryOptions.find(item => item.countryCNName === this.country)
                this.activeCountry = countryItem.id
                this.cityOptions = this.sortBySeq(countryItem.cityPartRecords)

                let cityItem = this.cityOptions.find(item => item.cityCNName === this.city)
                this.activeCity = cityItem.id
            },
            selectContinent (index) {
                this.activeContinent = index
                this.countryOptions = this.options[index].list
            },
            selectCountry (item) {
                this.activeCountry = item.id
                this.cityOptions = this.sortBySeq(item.cityPartRecords)
            },
            selectCity (item) {
                this.activeCity = item.id
                delayDev(200, () => {
                    window.location.href = `/Rccl.CustomPage/ShorexIntro/ShorexIntroList?cityName=${item.cityCNName}`
                })
            },
            close () {
                this.$emit('on-close')
            },
            sortBySeq (data) {
                if (!data || data.length === 0) return []
                return data.sort((item_1, item_2) => {
                    return item_1.seq - item_2.seq
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    .replacement-destination .replacementDestin-bg{
        position:absolute;
        width:100%;
        height:100%;
        top:40px;
        background:#000;
        opacity:.7;
        z-index:2;
    }
    .replacement-destination .destination-content{
        position:fixed;
        max-height: 350px;
        top:40px;
        width:100%;
        overflow-y:scroll;
        z-index:2;
        margin-left:-1px;
    }
    .destination-city li img{
        display: none;
        position:absolute;
        width:15px;
        right:5px;
        top:10px;
    }
    .destination-content .destinationCountry-city{
        position:fixed;
        background:#fff;
        top:40px;
        width:100%;
        border-top:1px solid #c8c8c8;
        color:#676767;
        font-size:12px;
    }
    .destinationCountry-city .destination-islet,
    .destinationCountry-city .destination-countryCity,
    .destination-countryCity .destination-country,
    .destination-countryCity .destination-city{
        display:inline-block;
        vertical-align:top;
    }
    .destinationCountry-city .destination-islet{
        width:116px;
        text-align:center;
        background:#f0f0f0;
        max-height:350px;
        overflow-x:hidden;
        overflow-y:scroll;
    }
    .destination-countryCity .destination-country,
    .destination-countryCity .destination-city{
        width:115px;
        text-align:center;
        padding:0 5px;
        max-height:350px;
        overflow-x:hidden;
        overflow-y:scroll;
    }
    .destination-countryCity .destination-country{
        border-right:1px solid #d3d3d3;
    }
    .destination-countryCity .destination-country li{
        border-bottom:1px solid #d3d3d3;
        padding:10px 0;
    }
    .destination-countryCity .destination-city li{
        border-bottom:1px solid #d3d3d3;
    }
    .destination-countryCity .destination-city li span a{
        padding:10px 0;
        display:inline-block;
        width:100%;
    }
    .destination-countryCity .destination-city li a{
        color:#666666;
        display:inline-block;
        width:100%;
    }
    .destination-countryCity .destination-city li{
        position:relative;
    }
    .destinationCountry-city .destination-islet li{
        border-bottom:1px solid #cbcbcb;
        padding:10px 0;
    }
    .destination-islet li.active{
        background:#061556;
        color:#fff;
    }
    .destination-country li.active,
    .destination-city li.active{
        color:#f0b11c;
    }
    .destination-city li.active span a{
        color:#f0b11c;
    }
    .destination-city li.active img{
        display: block;
    }
</style>
